define("calendar/services/note", ["exports", "@ember/service", "ember-concurrency", "later/utils/calendar/constants"], function (_exports, _service, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _getUnixTimeStamp, _hasValidTimeStamp;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"ember-concurrency",0,"later/utils/calendar/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let NoteService = (_class = (_getUnixTimeStamp = /*#__PURE__*/new WeakSet(), _hasValidTimeStamp = /*#__PURE__*/new WeakSet(), class NoteService extends _service.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _hasValidTimeStamp);

      _classPrivateMethodInitSpec(this, _getUnixTimeStamp);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "auth", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "router", _descriptor5, this);

      _initializerDefineProperty(this, "store", _descriptor6, this);
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    update(id, timeStamp) {
      const unixTime = _classPrivateMethodGet(this, _getUnixTimeStamp, _getUnixTimeStamp2).call(this, timeStamp);

      if (_classPrivateMethodGet(this, _hasValidTimeStamp, _hasValidTimeStamp2).call(this, unixTime, id)) {
        this.store.findRecord('calendar-note', id).then(calendarNote => {
          calendarNote.set('scheduledTime', unixTime);
          calendarNote.save().catch(() => {
            calendarNote.rollbackAttributes();
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.calendar_notes.problem_saving.title')
            });
          });
        });
      } else {
        this.alerts.alert(this.intl.t('alerts.calendar_notes.too_close_create.message'), {
          title: this.intl.t('alerts.calendar_notes.too_close_create.title')
        });
      }
    }

    create(timeStamp) {
      const unixTime = _classPrivateMethodGet(this, _getUnixTimeStamp, _getUnixTimeStamp2).call(this, timeStamp);

      if (_classPrivateMethodGet(this, _hasValidTimeStamp, _hasValidTimeStamp2).call(this, unixTime)) {
        this.router.transitionTo('cluster.schedule.calendar.notes.new', {
          queryParams: {
            scheduled_time: unixTime
          }
        });
      } else {
        this.alerts.alert(this.intl.t('alerts.calendar_notes.too_close_create.message'), {
          title: this.intl.t('alerts.calendar_notes.too_close_create.title')
        });
      }
    }

    shouldAllowSave(noteContent) {
      return this.getCharactersRemaining(noteContent) >= 0;
    }

    shouldShowCharacterLimit(noteContent) {
      return noteContent.length > _constants.NOTE_CHARACTER_LIMIT_THRESHOLD;
    }

    transitionToEdit(id) {
      this.router.transitionTo('cluster.schedule.calendar.notes.edit', id);
    }

    transitionToCalendar() {
      this.router.transitionTo('cluster.schedule.calendar');
    }

    getCharactersRemaining(noteContent) {
      return _constants.NOTE_MAXIMUM_CHARACTERS - noteContent.length;
    }

    *confirmClose(hasChanges) {
      if (hasChanges) {
        const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });

        if (!didConfirm) {
          return;
        }
      }

      this.transitionToCalendar();
    }

    *copyToClipboard(noteContent) {
      try {
        yield navigator.clipboard.writeText(noteContent);
        this.alerts.success(this.intl.t('alerts.calendar_notes.copy_to_clipboard_success'));
      } catch (error) {
        this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
          title: this.intl.t('alerts.calendar_notes.copy_to_clipboard_failure.title')
        });
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "confirmClose", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "confirmClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyToClipboard", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "copyToClipboard"), _class.prototype)), _class);
  _exports.default = NoteService;

  function _getUnixTimeStamp2(timeStamp) {
    return typeof timeStamp === 'number' ? timeStamp : timeStamp.unix() * 1000;
  }

  function _hasValidTimeStamp2(unixTime, excludedId) {
    if (!this.currentGroup.calendarNotes) {
      return true;
    }

    return this.currentGroup.calendarNotes.every(item => {
      if (item?.scheduledTime && item?.id !== excludedId) {
        // Notes fill 45 min block via css
        return Math.abs(item.scheduledTime - unixTime) > 2400;
      }

      return true;
    });
  }
});